type LoadDashboardIconProps = {
  className?: string;
};

export const LoadDashboardIcon = ({
  className,
}: LoadDashboardIconProps): React.ReactElement => (
  <svg
    className={className}
    id="dashboard-off"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.499 20.499"
  >
    <g id="menu" transform="translate(0 0)">
      <g id="Menu_icon_loads">
        <path
          id="Path_213"
          data-name="Path 213"
          d="M10.455,9.269H4.475V21.025H22.024V9.269H16.049v4.247a.737.737,0,0,1-.737.737h-4.12a.737.737,0,0,1-.737-.737Zm0-1.474V7.616a.737.737,0,0,1,.032-.214L11.68,3.474H7.051L4.923,7.8Zm2.7-4.321a.734.734,0,0,1-.026.306l-1.2,3.945v5.053h2.646V7.726l-1.2-3.945a.734.734,0,0,1-.026-.306Zm1.669,0L16.017,7.4a.737.737,0,0,1,.032.214V7.8h5.527L19.448,3.474Zm8.674,5.1s0,0,0,.007V21.762a.737.737,0,0,1-.737.737H3.738A.737.737,0,0,1,3,21.762V8.578s0-.008,0-.011a.732.732,0,0,1,.076-.361l2.855-5.8A.737.737,0,0,1,6.593,2H19.906a.737.737,0,0,1,.661.411l2.855,5.8A.731.731,0,0,1,23.5,8.571Z"
          transform="translate(-3 -2)"
        />
      </g>
    </g>
  </svg>
);
